import React from 'react'
import {Icon} from '@chakra-ui/react'

const EditIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="edit" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.3463 1.83702L38.162 14.6528L31.4574 21.3574L18.6416 8.54167L25.3463 1.83702ZM22.8842 8.54167L31.4574 17.1148L33.9194 14.6528L25.3463 6.07966L22.8842 8.54167Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.7633 6.42035L33.5791 19.2361L16.0374 36.7778H3.22168V23.962L20.7633 6.42035ZM6.22168 25.2047V33.7778H14.7948L29.3365 19.2361L20.7633 10.663L6.22168 25.2047Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default EditIcon
